
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as buttonsPaidpyuo6UVjbl7lIAMLR1NtRoNucPRzCf3RUvUDkacMeta } from "/home/userapp/app/pages/debug/buttons.vue?macro=true";
import { default as elasticsearch_45featuresE5607oyxEnorlHVvGe9wmAkWg_Sx_mL4pKlybgD_7mUMeta } from "/home/userapp/app/pages/debug/elasticsearch-features.vue?macro=true";
import { default as favoritesk5s2ptb7ehB4w6H7B5D8n5YMKPkAscsGZ_6VxIBvFTkMeta } from "/home/userapp/app/pages/debug/favorites.vue?macro=true";
import { default as formkitRLgoM6ZDJdlkOMuJSurXq2qQi4gi2TiQiwkI1fDHX_gMeta } from "/home/userapp/app/pages/debug/formkit.vue?macro=true";
import { default as link1O4aUpthSMgWjcorfNc1kI59xTqZRjNeBKhJWKxm_xwMeta } from "/home/userapp/app/pages/debug/link.vue?macro=true";
import { default as app_45health_45checkAW__1h9g2Di9fubI2WiLKIccFniibtixHpl71lipMukMeta } from "/home/userapp/app/pages/app-health-check.vue?macro=true";
import { default as indexb_3HqSr3YM0aP15Ar2Eim7dFLlDbRURlTrcDUOlTfeYMeta } from "/home/userapp/app/pages/debug/index.vue?macro=true";
export default [
  {
    name: "debug-buttons___nl",
    path: "/debug/buttons",
    meta: buttonsPaidpyuo6UVjbl7lIAMLR1NtRoNucPRzCf3RUvUDkacMeta || {},
    component: () => import("/home/userapp/app/pages/debug/buttons.vue")
  },
  {
    name: "debug-buttons___en",
    path: "/en/debug/buttons",
    meta: buttonsPaidpyuo6UVjbl7lIAMLR1NtRoNucPRzCf3RUvUDkacMeta || {},
    component: () => import("/home/userapp/app/pages/debug/buttons.vue")
  },
  {
    name: "debug-elasticsearch-features___nl",
    path: "/debug/elasticsearch-features",
    meta: elasticsearch_45featuresE5607oyxEnorlHVvGe9wmAkWg_Sx_mL4pKlybgD_7mUMeta || {},
    component: () => import("/home/userapp/app/pages/debug/elasticsearch-features.vue")
  },
  {
    name: "debug-elasticsearch-features___en",
    path: "/en/debug/elasticsearch-features",
    meta: elasticsearch_45featuresE5607oyxEnorlHVvGe9wmAkWg_Sx_mL4pKlybgD_7mUMeta || {},
    component: () => import("/home/userapp/app/pages/debug/elasticsearch-features.vue")
  },
  {
    name: "debug-favorites___nl",
    path: "/debug/favorites",
    meta: favoritesk5s2ptb7ehB4w6H7B5D8n5YMKPkAscsGZ_6VxIBvFTkMeta || {},
    component: () => import("/home/userapp/app/pages/debug/favorites.vue")
  },
  {
    name: "debug-favorites___en",
    path: "/en/debug/favorites",
    meta: favoritesk5s2ptb7ehB4w6H7B5D8n5YMKPkAscsGZ_6VxIBvFTkMeta || {},
    component: () => import("/home/userapp/app/pages/debug/favorites.vue")
  },
  {
    name: "debug-formkit___nl",
    path: "/debug/formkit",
    meta: formkitRLgoM6ZDJdlkOMuJSurXq2qQi4gi2TiQiwkI1fDHX_gMeta || {},
    component: () => import("/home/userapp/app/pages/debug/formkit.vue")
  },
  {
    name: "debug-formkit___en",
    path: "/en/debug/formkit",
    meta: formkitRLgoM6ZDJdlkOMuJSurXq2qQi4gi2TiQiwkI1fDHX_gMeta || {},
    component: () => import("/home/userapp/app/pages/debug/formkit.vue")
  },
  {
    name: "debug-link___nl",
    path: "/debug/link",
    meta: link1O4aUpthSMgWjcorfNc1kI59xTqZRjNeBKhJWKxm_xwMeta || {},
    component: () => import("/home/userapp/app/pages/debug/link.vue")
  },
  {
    name: "debug-link___en",
    path: "/en/debug/link",
    meta: link1O4aUpthSMgWjcorfNc1kI59xTqZRjNeBKhJWKxm_xwMeta || {},
    component: () => import("/home/userapp/app/pages/debug/link.vue")
  },
  {
    name: "education-slug___nl",
    path: "/education-redirect/:eventGroupId()/event/:eventId()/educatie/projecten/:slug()",
    component: () => import("/home/userapp/app/pages/education/[slug].vue")
  },
  {
    name: "education-slug___en",
    path: "/en/remove-from-route--926bb34a4259a5030823522d31e106fa",
    component: () => import("/home/userapp/app/pages/education/[slug].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"i18n":false},
    component: () => import("/home/userapp/app/pages/admin.vue"),
    children: [
  {
    name: "admin-slug",
    path: ":slug(.*)*",
    meta: {"i18n":false},
    component: () => import("/home/userapp/app/pages/admin/[...slug].vue")
  }
]
  },
  {
    name: "app-health-check___nl",
    path: "/app-health-check",
    meta: app_45health_45checkAW__1h9g2Di9fubI2WiLKIccFniibtixHpl71lipMukMeta || {},
    component: () => import("/home/userapp/app/pages/app-health-check.vue")
  },
  {
    name: "app-health-check___en",
    path: "/en/app-health-check",
    meta: app_45health_45checkAW__1h9g2Di9fubI2WiLKIccFniibtixHpl71lipMukMeta || {},
    component: () => import("/home/userapp/app/pages/app-health-check.vue")
  },
  {
    name: "debug___nl",
    path: "/debug",
    meta: indexb_3HqSr3YM0aP15Ar2Eim7dFLlDbRURlTrcDUOlTfeYMeta || {},
    component: () => import("/home/userapp/app/pages/debug/index.vue")
  },
  {
    name: "debug___en",
    path: "/en/debug",
    meta: indexb_3HqSr3YM0aP15Ar2Eim7dFLlDbRURlTrcDUOlTfeYMeta || {},
    component: () => import("/home/userapp/app/pages/debug/index.vue")
  },
  {
    name: "education-user-edit___nl",
    path: "/educatie/gebruiker/aanpassen",
    component: () => import("/home/userapp/app/pages/education-user-edit.vue")
  },
  {
    name: "education-user-edit___en",
    path: "/en/remove-from-route--61586b0c04b3878de7bebccea5977e03c6725033",
    component: () => import("/home/userapp/app/pages/education-user-edit.vue")
  },
  {
    name: "slug___nl",
    path: "/:slug(.*)*",
    component: () => import("/home/userapp/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/home/userapp/app/pages/[...slug].vue")
  },
  {
    name: "index___nl",
    path: "/",
    component: () => import("/home/userapp/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/userapp/app/pages/index.vue")
  }
]